@if (!(alertsLoading$ | async)) {
  <div class="pane flat">
    <div class="alerts">
      <div class="alerts-header">
        <h5>
          <fa-icon [icon]="['fas', 'bell']"></fa-icon>
          {{ "alerts-center.title.alerts-center" | translate }}
        </h5>
        @if (
          userFacade.hasPermissionSync(
            AppFeatures.ADVANCED_MASS_OPERATIONS_ROOT
          )
        ) {
          <sui-toolbar>
            <app-search-input
              [placeholder]="'feed-actions.placeholder.search' | translate"
              [value]="searchQuery"
              (inputChanged)="handleSearchStringAlertChange($event)"
            ></app-search-input>
          </sui-toolbar>
        }
      </div>
      <div class="alerts-holder">
        @if (alerts?.length > 0) {
          @for (alert of alerts; track trackByAlertId($index, alert)) {
            <app-alert-card
              [alert]="alert"
              [searchQuery]="searchQuery"
              (alertEdit)="editAlert($event)"
              (alertDelete)="deleteAlert($event)"
            ></app-alert-card>
          }
        } @else {
          <p class="no-alerts">
            {{ "alerts-center.message.no-alerts" | translate }}
          </p>
        }
      </div>
    </div>
  </div>
} @else {
  <app-loading></app-loading>
}
